import { render, staticRenderFns } from "./CostTotals.vue?vue&type=template&id=74e05878&scoped=true&"
import script from "./CostTotals.vue?vue&type=script&lang=js&"
export * from "./CostTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e05878",
  null
  
)

export default component.exports